var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_svg__a",
    x1: 31.748,
    x2: 31.748,
    y1: 767.957,
    y2: 762.844,
    gradientTransform: "matrix(1 0 0 -1 -17.248 814.853)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#support_svg__a)",
    d: "M14.5 47a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_svg__b",
    x1: 50.651,
    x2: 9.186,
    y1: 13.359,
    y2: 54.824,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#support_svg__b)",
    d: "M39.959 9c2.007 0 3.884.698 5.475 2.028l-6.522 6.517a3.087 3.087 0 0 0-.912 2.2c0 .831.324 1.613.911 2.2l3.145 3.144c.588.587 1.369.911 2.2.911s1.613-.324 2.2-.911l6.523-6.518c1.422 1.702 2.115 3.731 2.011 5.917-.12 2.511-1.326 5.034-3.397 7.104C49.396 33.79 46.724 35 44.07 35c-1.978 0-3.855-.678-5.426-1.96l-1.499-1.223-1.272 1.458-17.336 19.869A5.382 5.382 0 0 1 14.452 55a5.493 5.493 0 0 1-3.858-1.597 5.46 5.46 0 0 1-1.591-4.029 5.46 5.46 0 0 1 1.853-3.913l19.873-17.33 1.453-1.267-1.213-1.499c-2.354-2.909-2.658-6.979-.757-10.129 2.084-3.456 5.329-5.763 8.68-6.172A9.144 9.144 0 0 1 39.959 9m0-2c-.433 0-.869.027-1.308.08-3.956.483-7.752 3.145-10.151 7.124-2.366 3.92-1.958 8.87.915 12.42L9.542 43.953a7.472 7.472 0 0 0-2.538 5.354 7.469 7.469 0 0 0 2.176 5.51 7.483 7.483 0 0 0 5.514 2.179 7.363 7.363 0 0 0 5.348-2.535L37.379 34.59c1.975 1.611 4.303 2.41 6.69 2.41 3.093 0 6.286-1.341 8.938-3.992 5.011-5.01 5.341-11.951.786-16.505l-.786-.786-7.965 7.958a1.107 1.107 0 0 1-.786.325c-.285 0-.569-.108-.786-.325l-3.145-3.144a1.112 1.112 0 0 1 0-1.572l7.965-7.958-.786-.786C45.405 8.116 42.764 7 39.959 7zm-9.252 27.707-1.414-1.414-11 11 1.414 1.414 11-11z"
  })));
};
export default SvgSupport;